import { render, staticRenderFns } from "./applied-positions.vue?vue&type=template&id=36d20c88"
import script from "./applied-positions.vue?vue&type=script&lang=js"
export * from "./applied-positions.vue?vue&type=script&lang=js"
import style0 from "./applied-positions.vue?vue&type=style&index=0&id=36d20c88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports